import Vue from 'vue'
import * as jsonpatch from 'fast-json-patch/index.mjs'

const luExciseProjectionType = {
  state: {
    luExciseProjectionType: [],
    selectedLuExciseProjectionType: {},
    selectedLuExciseProjectionTypeOriginal: {},
    saving: false,
    searchCount: 0,
  },

  getters: {
    luExciseProjectionType(state) {
      return state.luExciseProjectionType
    },
    selectedLuExciseProjectionType(state) {
      return state.selectedLuExciseProjectionType
    },
    selectedLuExciseProjectionTypeOriginal(state) {
      return state.selectedLuExciseProjectionTypeOriginal
    },
    loading(state) {
      return state.searchCount > 0
    },
  },

  mutations: {
    luExciseProjectionType(state, payload) {
      state.luExciseProjectionType = payload
    },
    selectedLuExciseProjectionType(state, payload) {
      state.selectedLuExciseProjectionType = JSON.parse(JSON.stringify(payload))
    },
    selectedLuExciseProjectionTypeOriginal(state, payload) {
      state.selectedLuExciseProjectionTypeOriginal = JSON.parse(JSON.stringify(payload))
    },
    saving(state, payload) {
      state.saving = payload
    },
    searchCount(state, payload) {
      state.searchCount = payload
    },
    increaseSearchCount(state, payload) {
      state.searchCount = state.searchCount + 1
    },
    decreaseSearchCount(state, payload) {
      state.searchCount = state.searchCount - 1
    },
  },

  actions: {
    setSelectedLuExciseProjectionType(context, payload) {
      context.commit('selectedLuExciseProjectionType', payload)
    },
    loadLuExciseProjectionType(context, payload) {
      return new Promise((resolve, reject) => {
        const url = 'LuExciseProjectionType'
        Vue.prototype.$axios
        .get(url)
        .then(
          (res) => {
            context.commit('luExciseProjectionType', res.data)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          },
        )
      })
    },
    refreshSelectedLuExciseProjectionType(context, payload) {
      if (context.state.selectedLuExciseProjectionType && context.state.selectedLuExciseProjectionType.ID > 0) {
        context.dispatch('loadSelectedLuExciseProjectionType', context.state.selectedLuExciseProjectionType.ID)

      }
    },
    loadSelectedLuExciseProjectionType(context, payload) {
      if (context.state.selectedLuExciseProjectionType && context.state.selectedLuExciseProjectionType.ID != payload) {
        context.commit('selectedLuExciseProjectionType', {})
      }
      return new Promise((resolve, reject) => {
        const url = 'LuExciseProjectionType/' + payload
        context.commit('increaseSearchCount')
        Vue.prototype.$axios
        .get(url)
        .then(
          (res) => {
            context.commit('selectedLuExciseProjectionType', res.data)
            context.commit('selectedLuExciseProjectionTypeOriginal', res.data)
            context.commit('decreaseSearchCount')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.commit('decreaseSearchCount')
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          },
        )
      })
    },
    clearLookupCacheAndReloadLuExciseProjectionType(context, payload) {
      caches.delete('apilookup-cache').finally(() => {
          context.dispatch('loadLuExciseProjectionType')
      }, )
    },
    createLuExciseProjectionType(context, payload){
      return new Promise((resolve, reject) => {
        const url = `LuExciseProjectionType`
        context.commit('saving', true)
        Vue.prototype.$axios
        .post(url, payload)
        .then(
          (res) => {
            context.dispatch('messages/toastMessage',
            {color: 'success', message: 'excise projection type created',},{ root: true })
            //if you will always need to reload the list after an item is created
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadLuExciseProjectionType')
            context.commit('saving', false)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.commit('saving', false)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          },
        )
      })
    },
    patchLuExciseProjectionType(context, payload){
      return new Promise((resolve, reject) => { 
        var item = context.state.selectedLuExciseProjectionType
        if (payload.ID && 
        payload.ID == context.state.selectedLuExciseProjectionTypeOriginal.ID)  {
        item = payload
        }
        var patchPayload = {}
        if (!payload.patchDoc || !payload.ID) {
          let original = context.state.selectedLuExciseProjectionTypeOriginal
          let current = item
          patchPayload.ID = item.ID
          var diff = jsonpatch.compare(
                original,
                current
              )
          patchPayload.patchDoc = diff

        } else {
          patchPayload = payload
        }
        if (patchPayload.patchDoc.length > 0) {
          const url = `LuExciseProjectionType/${ patchPayload.ID }`
          context.commit('saving', true)
          Vue.prototype.$axios
          .patch(url, patchPayload.patchDoc)
          .then(
            (res) => {
              context.dispatch('messages/toastMessage',
              {color: 'success', message: 'excise projection type updated',},{ root: true })
              //if you will always need to reload the list after an update
              //you can uncomment out the following dispatch line.
              //Alternatively you can reload whatever object you need
              //when the promise resolves in the component that called it.
              //context.dispatch('loadLuExciseProjectionType')
              context.commit('saving', false)
              resolve(res)
            },
            (err) => {
              console.error(err)
              context.commit('saving', false)
              context.dispatch('errors/handleError', err, { root: true })
              reject(err)
            },
          )
        } else {
          resolve('no changes')
        }
      })
    },
    updateLuExciseProjectionType(context, payload){
      return new Promise((resolve, reject) => { 
        const url = `LuExciseProjectionType/${ payload.ID }`
        context.commit('saving', true)
        Vue.prototype.$axios
        .put(url, payload)
        .then(
          (res) => {
            context.dispatch('messages/toastMessage',
            {color: 'success', message: 'excise projection type updated',},{ root: true })
            //if you will always need to reload the list after an update
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadLuExciseProjectionType')
            context.commit('saving', false)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.commit('saving', false)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          },
        )
      })
    },
    saveLuExciseProjectionType(context, payload){
      return new Promise((resolve, reject) => {
        if (payload.ID > 0) {
          context.dispatch('updateLuExciseProjectionType', payload)
          .then((res) => resolve(res), (err) => reject(err))
        } else {
          context.dispatch('createLuExciseProjectionType', payload)
          .then((res) => resolve(res), (err) => reject(err))
        }
      })
    },
    deleteLuExciseProjectionType(context, payload){
      return new Promise((resolve, reject) => {
        const url = `LuExciseProjectionType/${ payload.ID }`
        Vue.prototype.$axios
        .delete(url)
        .then(
          (res) => {
            context.dispatch('messages/toastMessage',
            {color: 'success', message: 'excise projection type deleted',},{ root: true })
            //if you will always need to reload the list after a delete
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadLuExciseProjectionType')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          },
        )
      })
    },
  },
}

export default luExciseProjectionType